import { http, type ApiResponse, type ButtonShow } from '@/shared/api'
import type { SystemKeyVm } from '../model/systemkey.model'
import type { SystemKeyInput } from '../model/systemkey.param'
import {
  apiSystemKey,
  apiSystemKeyAdminList,
  apiSystemKeyBulkDelete,
  apiSystemKeyById,
  apiSystemKeyByParent,
  apiSystemKeyClearAllCache,
  apiSystemKeyCombobox,
  apiSystemKeyInvalidateCache,
} from './systemkey.urls'

export interface SystemKeyAdminListVm {
  items: SystemKeyVm[]
  totalItems: number
  buttonShow?: ButtonShow
  isSuperAdmin: boolean
}

export interface SystemKeyAdminListInput {
  currentPage: number
  pageSize: number
  query?: string
}

const toAdminListQuery = (input: SystemKeyAdminListInput): string => {
  const params = new URLSearchParams()
  params.set('currentPage', String(input.currentPage))
  params.set('pageSize', String(input.pageSize))
  if (input.query) params.set('query', input.query)
  return params.toString()
}

const getList = (): Promise<ApiResponse<SystemKeyVm[]>> => http.get(apiSystemKey)
/** Màn quản trị Tham số hệ thống — khác `getList` (public, không quyền) ở chỗ có kèm buttonShow + phân trang. */
const getListForAdmin = (
  input: SystemKeyAdminListInput
): Promise<ApiResponse<SystemKeyAdminListVm>> =>
  http.get(`${apiSystemKeyAdminList}?${toAdminListQuery(input)}`)
const getDetail = (id: number): Promise<ApiResponse<SystemKeyVm>> => http.get(apiSystemKeyById(id))
const getByParent = (codeKey: string): Promise<ApiResponse<SystemKeyVm[]>> =>
  http.get(`${apiSystemKeyByParent}?codeKey=${encodeURIComponent(codeKey)}`)
const getCombobox = (codeKey?: string): Promise<ApiResponse<SystemKeyVm[]>> =>
  http.get(
    codeKey
      ? `${apiSystemKeyCombobox}?codeKey=${encodeURIComponent(codeKey)}`
      : apiSystemKeyCombobox
  )
const create = (body: SystemKeyInput): Promise<ApiResponse> => http.post(apiSystemKey, body)
const update = (id: number, body: SystemKeyInput): Promise<ApiResponse> =>
  http.put(apiSystemKeyById(id), body)
const deleteById = (id: number): Promise<ApiResponse> => http.delete(apiSystemKeyById(id))
const bulkDelete = (ids: number[]): Promise<ApiResponse> =>
  http.post(apiSystemKeyBulkDelete, { ids })
const clearAllCache = (): Promise<ApiResponse> => http.post(apiSystemKeyClearAllCache)
const invalidateCache = (): Promise<ApiResponse> => http.post(apiSystemKeyInvalidateCache)

const systemkeyService = {
  getList,
  getListForAdmin,
  getDetail,
  getByParent,
  getCombobox,
  create,
  update,
  deleteById,
  bulkDelete,
  invalidateCache,
  clearAllCache,
}
export default systemkeyService
